<template>
  <div class="group_check">
    <CheckboxItem v-for="(item, index) in dataList" :key="index"
      :id="item.id"
      :text="item.text"
      :value="item"
      :style="itemStyle"
      :isDisabled="isDisabled || item.isDisabled || isSingleCheck(item.id)"
      :checkedNames.sync="checkedNamesSync" />
  </div>
</template>

<script>
import CheckboxItem from './CheckboxItem'

export default {
  name: 'Checkbox',
  components: {
    CheckboxItem
  },
  props: {
    dataList: Array,
    checkedNames:Array,
    isDisabled: {
      type: Boolean,
      default: false
    },
    itemStyle: String
  },
  computed: {
    checkedNamesSync: {
      get() {
        return this.checkedNames;
      },
      set(value) {
        this.$emit("update:checkedNames", value);
      }
    }
  },
  methods: {
    isSingleCheck(id) {
      return this.checkedNames.length === 1 && id === this.checkedNames[0].id;
    }
  }
}
</script>
